// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_11tDeOXA1Fb2JbD75OlKna_0","header":"_18zMn3Km8bnWbhFKCv1dBU_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63cf77b8","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OrderList/Content.vue
// module id = XZQi
// module chunks = 1